"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NSS_PATTERN = void 0;
exports.validateNSS = validateNSS;
exports.normalizeNSS = normalizeNSS;
/**
 * Validates NSS (Número de Seguridad Social) format
 *
 * NSS is the Mexican social security number issued by IMSS.
 * Format: 11 digits (e.g., 12345678901)
 *
 * Note: This performs basic format validation only (11 digits).
 *
 * @param value - NSS to validate
 * @returns ValidationResult with isValid flag and optional error message
 */
function validateNSS(value) {
    if (!value || !value.trim()) {
        return { isValid: false, error: 'NSS es requerido' };
    }
    const normalized = value.trim();
    // NSS format: exactly 11 digits
    const nssPattern = /^\d{11}$/;
    if (!nssPattern.test(normalized)) {
        return { isValid: false, error: 'NSS inválido. Debe tener exactamente 11 dígitos' };
    }
    return { isValid: true };
}
/**
 * Normalizes NSS by trimming whitespace
 *
 * @param value - NSS to normalize
 * @returns Normalized NSS
 */
function normalizeNSS(value) {
    return value.trim();
}
/**
 * Regex pattern for NSS validation
 * Can be used directly in form libraries that accept regex
 */
exports.NSS_PATTERN = /^\d{11}$/;
